import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { ITimeZoneDTO, ITimeZonesDAO } from '../timezones.dao';

class TimeZonesDAO extends ITimeZonesDAO {
    static readonly timeZonesUrl: string = 'timezone/list';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getTimeZones(): Promise<ITimeZoneDTO[]> {
        const response = await this.apiClient.get<ITimeZoneDTO[]>(TimeZonesDAO.timeZonesUrl);
        return response.parsedResponse;
    }
}

export { TimeZonesDAO };